import { CronFormItem } from './formItems'
import { Button, Card, Divider, Form, Skeleton } from 'antd'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useRouteMatch } from 'react-router-dom'
import moment from 'moment'
import './index.scss'

export default function CronForm ({ form, orchestrator }) {
  const { params: { taskId }} = useRouteMatch()

  const [disabledCrons, setDisabledCrons] = useState([])

  const getSchedule = async () => {
    const res = await orchestrator.getSchedule({ scheduleUid: taskId });
    return JSON.parse(res);
  }

  const task = useQuery({
    queryKey: [`pipelines.tasks.${taskId}`],
    queryFn: getSchedule,
    enabled: (taskId !== 'new'),
    onSuccess: (data) => fillDefaultValues(data)
  })

  const fillDefaultValues = ({ crons }) => {
    const values = crons.map(({ nextRun, cron, runOnce, uid }) => {

      (_.isEmpty(cron.value) && runOnce === false) ? disabledCrons[uid] = true : disabledCrons[uid] = false

      return {
        uid,
        cron,
        firstRun: moment(nextRun),
        runOnce
      }
    }).filter(({ firstRun }) => moment(firstRun).isAfter(moment()))
    form.setFieldsValue({ crons: values })
  }

  const disableCron = (cronUid) => {
    const cronData = {
      cronUid,
      runOnce: false,
      firstRun: -1,
      cron: {}
    }
    orchestrator.updateCron(cronData)
    setDisabledCrons([...disabledCrons, cronUid])
  }

  const disableButton = (cronUid) => {
    if (disabledCrons.find((_cronUid) => _cronUid === cronUid)) {
      return <span style={{ color: '#00000040' }}>Disabled</span>
    } else {
      return (
        <span
          style={{ color: 'red', cursor: 'pointer' }}
          onClick={() => disableCron(cronUid)}
        >
          Disable
        </span>
      )
    }
  }

  const cronUid = (fieldName) => form.getFieldValue(['crons', fieldName, 'uid'])

  const renderExtra = (field, remove) => {
    if (cronUid(field.name)) {
      return disableButton(cronUid(field.name))
    } else {
      return (
        <DeleteOutlined
          onClick={() => remove(field.name)}
          style={{ color: 'red' }}
        />
      )
    }
  }

  return (
    <Skeleton
      active
      loading={taskId !== 'new' ? task.isLoading : false}
    >
      <Divider>Crons</Divider>
      <Form
        form={form}
        name="cronForm"
      >
        <Form.Item noStyle>
          <Form.List name="crons">
            {(fields, { add, remove }) =>
              <>
                {
                  fields.map((field) =>
                    <Card
                      extra={renderExtra(field, remove)}
                      key={field.name}
                      style={{ margin: '20px 0px' }}
                    >
                      <CronFormItem
                        disabled={disabledCrons.find((_cronUid) => _cronUid === cronUid(field.name))}
                        field={field}
                        form={form}
                      />
                    </Card>
                  )
                }
                <Form.Item>
                  <Button
                    type="dashed"
                    data-testid="add-cron-bttn"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Cron
                  </Button>
                </Form.Item>
              </>
            }
          </Form.List>
        </Form.Item>
      </Form>
    </Skeleton>
  )
}

